export default function toggle() {

    const deployThis = document.querySelectorAll(".js-click-to-deploy");

    deployThis.forEach(function (deployBtn) {
      deployBtn.onclick = () => {
        let i = deployBtn.dataset.targetdeploy;
        let targetToDeploy = document.querySelector(
          ".js-deploy[data-deploy=deploy-" + i + "]"
        );
        let targetToDeployWrapper =
          targetToDeploy.querySelector(".js-deploy-wrapper");

        // Fermer tous les autres toggles
        deployThis.forEach(function (otherBtn) {
          if (otherBtn !== deployBtn && otherBtn.classList.contains("active")) {
            let otherIndex = otherBtn.dataset.targetdeploy;
            let otherTarget = document.querySelector(
              ".js-deploy[data-deploy=deploy-" + otherIndex + "]"
            );
            let otherWrapper = otherTarget.querySelector(".js-deploy-wrapper");

            otherWrapper.style.height = "0px";
            otherTarget.style.height = "0px";
            otherTarget.classList.remove("active");
            otherBtn.classList.remove("active");
          }
        });

        // Toggle le bouton actuel
        if (deployBtn.classList.contains("active")) {
          targetToDeployWrapper.style.height = "0px";
          targetToDeploy.style.height = "0px";
          targetToDeploy.classList.remove("active");
          deployBtn.classList.remove("active");
        } else {
          targetToDeployWrapper.style.height = "auto";          
          let wrapperHeight = targetToDeployWrapper.offsetHeight + 20;
          targetToDeploy.style.height = wrapperHeight + "px";
          targetToDeploy.classList.add("active");
          deployBtn.classList.add("active");
        }
      };
    });

    // Mdoule Image + Toggle
    const modules = document.querySelectorAll(".m-image-toogle-list");

    modules.forEach(function (module) {
      const deployThis = module.querySelectorAll(".js-click-to-deploy");
      const imageWrapper = module.querySelector(".m-image-toogle__img-wrap");
      const imageElement = module.querySelector(
        ".m-image-toogle__img-wrap .m-image-toogle__image"
      );

      const defaultImage = imageElement; // Sauvegarder l'URL de l'image de base

      deployThis.forEach(function (deployBtn) {
        deployBtn.onclick = () => {
          let i = deployBtn.dataset.targetdeploy;
          let targetToDeploy = module.querySelector(
            ".js-deploy[data-deploy=deploy-" + i + "]"
          );
          let targetToDeployWrapper =
            targetToDeploy.querySelector(".js-deploy-wrapper");

          let ImageToDeploy = module.querySelector(
            ".js-image[data-image=image-" + i + "]"
          );
          let targetToDeployImage = imageElement;
          if (ImageToDeploy) {
            targetToDeployImage = ImageToDeploy.querySelector(
              ".m-image-toogle__image"
            );
          }

          // Fermer tous les autres toggles dans le même module
          deployThis.forEach(function (otherBtn) {
            if (otherBtn !== deployBtn && otherBtn.classList.contains("active")) {
              let otherIndex = otherBtn.dataset.targetdeploy;
              let otherTarget = module.querySelector(
                ".js-deploy[data-deploy=deploy-" + otherIndex + "]"
              );
              let otherWrapper = otherTarget.querySelector(".js-deploy-wrapper");

              otherWrapper.style.height = "0px";
              otherTarget.classList.remove("active");
              otherBtn.classList.remove("active");

              imageWrapper.innerHTML = "";
              imageWrapper.appendChild(defaultImage); // Réafficher l'image de base si pas de data-illustration
            }
          });

          // Toggle le bouton actuel
          if (deployBtn.classList.contains("active")) {
            targetToDeployWrapper.style.height = "0px";
            targetToDeploy.classList.remove("active");
            deployBtn.classList.remove("active");
            imageWrapper.innerHTML = "";
            imageWrapper.appendChild(defaultImage); // Réafficher l'image de base
          } else {
            targetToDeployWrapper.style.height =
              targetToDeployWrapper.scrollHeight + "px";
            targetToDeploy.classList.add("active");
            deployBtn.classList.add("active");

            // Mettre à jour l'image
            const newImageUrl = targetToDeployImage.cloneNode(true);
            if (newImageUrl) {
              imageWrapper.innerHTML = ""; // Supprimer l'image de base
              imageWrapper.appendChild(newImageUrl);
            } else {
              imageWrapper.innerHTML = "";
              imageWrapper.appendChild(defaultImage); // Réafficher l'image de base si pas de data-illustration
            }
          }
        };
      });
    });
}